<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>物料管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">网点仓物料</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsDetail">
      <section class="searchBox">
        <span>
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="width:200px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>设备厂商：</label>
          <a-radio-group v-model="firm_id">
            <a-radio :value="1">易触</a-radio>
            <a-radio :value="2">华屹1</a-radio>
            <a-radio :value="3">华屹2</a-radio>
            <a-radio :value="4">卡游</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>设备类型：</label>
          <a-radio-group v-model="version">
            <a-radio :value="1">一代机</a-radio>
            <a-radio :value="2">二代机</a-radio>
            <a-radio :value="3">三代机</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>销售情况：</label>
          <a-radio-group v-model="sale_type">
            <a-radio :value="1">非热销</a-radio>
            <a-radio :value="2">热销</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="网点设备机器名称|机器码|网点详细地址|商品名称"
            style="width:200px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button class="resetStyle" @click="downloadCost">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>{{ item.device_name }}</td>
              <td>
                <p v-show="item.firm_id == 1">易触</p>
                <p v-show="item.firm_id == 2">华屹1</p>
                <p v-show="item.firm_id == 3">华屹2</p>
                <p v-show="item.firm_id == 4">卡游</p>
                <p v-show="item.firm_id == 0">未知</p>
              </td>
              <td>
                <p v-show="item.sale_type == 1">非热销</p>
                <p v-show="item.sale_type == 2">热销</p>
                <p v-show="item.sale_type == 0">未知</p>
              </td>
              <td>{{ item.brand_name }}</td>
              <td><img :src="item.imageUrl.url_thumb" alt="" /></td>
              <td>{{ item.inventory }}</td>
              <td>{{ item.real_inventory }}</td>
              <td>
                <a @click="detailPage(item)" style="color:#777">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 详情 -->
    <deviceMaterialDetail v-show="showIsDetail" :detailVal="detailVal" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import deviceMaterialDetail from "@/components/equipment/deviceMaterialDetail"; //详情
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目名称",
        "网点设备名称",
        "厂商",
        "销售类型",
        "商品名称",
        "商品图",
        "总入库数量",
        "现存数量",
        "操作"
      ],
      project_id: "",
      query_field: "",
      proList: [],
      firm_id: "",
      version: "",
      sale_type: "",
      detailVal: "",
      showIsDetail: false
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    deviceMaterialDetail
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  methods: {
    backHref() {
      this.showIsDetail = false;
    },
    detailPage(item) {
      console.log(item);
      this.detailVal = item;
      this.showIsDetail = true;
    },
    downloadCost() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device_material/downloadLists?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&device_id=" +
        this.device_id +
        "&firm_id=" +
        this.firm_id +
        "&project_id=" +
        this.project_id +
        "&version=" +
        this.version +
        "&sale_type=" +
        this.sale_type;
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.query_field = "";
      this.project_id = "";
      this.firm_id = "";
      this.sale_type = "";
      this.version = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device_material/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        firm_id: this.firm_id,
        version: this.version,
        sale_type: this.sale_type,
        project_id: this.project_id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
